import React from "react";
import { ViolationListContainer } from "./style";

const ViolationList = () => {
  return <ViolationListContainer>ViolationList</ViolationListContainer>;
};

export default ViolationList;
